import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const AnalyticsCro = () => {
  const service = getDigitalMarketingService('analytics-and-cro');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default AnalyticsCro;
